import { AGENCIES } from 'constants/constants';

export default function getCarrierName(code = '') {
  return AGENCIES[code]?.name || code;
}
